<i18n>
{
    "en_US": {
        "label": "Confirm password"
    },
    "fr_FR": {
        "label": "Confirmation du mot de passe"
    }
}
</i18n>

<template>
    <div class="input-group mb-3 bmd-form-group">
        <label for="inputConfirmPassword" class="bmd-label-floating" v-text="$t('label')"></label>
        <input id="inputConfirmPassword" type="password" class="form-control bmb-control" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" v-bind:disabled="disabled" required />
        <div class="input-group-append">
            <a class="input-group-text" id="basic-addon2">
                <i v-if="isConfirmed" class="fa fa-check text-success"></i>
                <i v-else class="fa fa-times text-danger"></i>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PasswordConfirm",
        props: {
            value: String,
            password: String,
            disabled: Boolean
        },
        computed: {
            isConfirmed: function() {
                return this.value === this.password && this.value;
            }
        }
    }
</script>

<style scoped>
    input {
        border-right: 0;
    }
    label {
        font-weight: bold;
        font-size: 14px;
    }
    a {
        cursor: pointer;
        background-color: #fff;
        border-left: 0;
    }
    a .fa-check {
        display: inline-block;
        padding-left: 5px;
    }
    a .fa-times {
        display: inline-block;
        padding-left: 10px;
    }
    i {
        color: #949ba1;
    }
</style>